import { Outlet } from 'react-router-dom';
import { Topbar } from './Topbar';

/**
 * Wraps every route with the Topbar shell. Pages are responsible for their
 * own SectionNav placement and footer:
 *   - HomePage puts SectionNav AFTER the hero.
 *   - Inner pages put SectionNav at the top (right under the Topbar).
 *   - Every data page except Map (full-viewport, footer-less) renders the
 *     shared `CewSiteFooter` (CR-030) — a replica of cew.georgetown.edu's
 *     own global footer plus a funder credit strip. Replaces the old
 *     per-context `HomePageFooter` / `Footer` split.
 *
 * This keeps SharedLayout minimal (just the persistent shell) and lets each
 * page own its narrative structure — matches the static prototype where
 * the homepage and inner pages have very different vertical rhythms.
 *
 * `overflow-x-clip` is a defense-in-depth safety net against full-bleed
 * pseudo-elements (e.g. SectionShell's alt-variant `::before` bleed) ever
 * producing horizontal overflow on mobile (BUG-003, 2026-06-01).
 */
export function SharedLayout() {
  return (
    <div className="flex min-h-screen flex-col overflow-x-clip bg-white">
      <a href="#main" className="skip-link">
        Skip to main content
      </a>
      <Topbar />
      <main id="main" className="flex-1" tabIndex={-1}>
        <Outlet />
      </main>
    </div>
  );
}
